// removed by extract-text-webpack-plugin
module.exports = {"spinner":"Spinner__spinner___3q8xb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Spinner/Spinner.scss
// module id = 1257
// module chunks = 1